(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("GPTTokenizer_p50k_edit", [], factory);
	else if(typeof exports === 'object')
		exports["GPTTokenizer_p50k_edit"] = factory();
	else
		root["GPTTokenizer_p50k_edit"] = factory();
})(globalThis, () => {
return 